<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.title"
      [subheader]="data.p1"
      [imageUrl]="$any(data.avatar_url)"
    />
  </ng-container>

  <ng-container body>
    <ng-container *mailgunFor="let notification of data.notifications; let isFirst = first">
      <ng-container *mailgunIf="isFirst; else notFirst">
        <email-notification [body]="notification.html" [avatar]="notification.avatar_url" />
      </ng-container>

      <ng-template #notFirst>
        <email-margin [height]="16" />
        <hr />
        <email-margin [height]="16" />
        <email-notification [body]="notification.html" [avatar]="notification.avatar_url" />
      </ng-template>
    </ng-container>

    <email-margin [height]="32" />
    <email-button [href]="data.button_link" [label]="data.button_text" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer_p1" color="light" presetName="inline" size="small" /><br />
    <email-link
      [label]="data.footer_link_text"
      [href]="data.footer_link"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
